/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Loader} from 'react-overlay-loader';
import * as actions from '../../store/actions';
import {colors} from "../dashboard/colors";
import moment from 'moment';
import maleAvatar from '../../assets/images/Male-Avatar.png';
import computerIcon from "../../assets/images/computer-icon-hover.png";
import alertsIcon from '../../assets/images/alerts-icon.png';
import '../../assets/css/chart.css';
import {
    RadialChart,
    DiscreteColorLegend,
    Hint,
    HorizontalGridLines,
    VerticalGridLines,
    XAxis,
    YAxis,
    VerticalBarSeries,
    LineMarkSeries,
    FlexibleWidthXYPlot
} from 'react-vis';
// import DateRangePicker from "./DateRangePicker";

const options = [
    {value: 'onDemand', label: 'OnDemand'},
    {value: 'yr1CudCosts', label: '1-year Resource-based CUD'},
    {value: 'yr3CudCosts', label: '3-year Resource-based CUD'},
];


class GcpDashboard extends Component {
    state = {
        hoveredCell: false,
        reservationType: 'onDemand',
        selectedReservationType: null,
        filter: this.props.filter,
        filterCat: this.props.filterCat,
        scope: this.props.scope,
        plan: this.props.plan,
    };

    componentDidMount() {
        window.$(function () {
            window.jcf.replaceAll();
        });
        window.$(function () {
            window.$('[data-toggle="offcanvas"]').on('click', function () {
                window.$('.offcanvas-collapse').toggleClass('open')
            });
        });

        let bindDateRangeValidation = function (f, s, e) {
            if (!(f instanceof window.jQuery)) {
                console.log("Not passing a jQuery object");
            }

            let jqForm = f,
                startDateId = s,
                endDateId = e;

            let checkDateRange = function (startDate, endDate) {
                let isValid = (startDate !== "" && endDate !== "") ? startDate <= endDate : true;
                return isValid;
            };

            let bindValidator = function () {
                let bstpValidate = jqForm.data('bootstrapValidator');
                let validateFields = {
                    startDate: {
                        validators: {
                            notEmpty: {message: 'This field is required.'},
                            callback: {
                                message: 'Start Date must less than or equal to End Date.',
                                callback: function (startDate, validator, $field) {
                                    return checkDateRange(startDate, window.$('#' + endDateId).val())
                                }
                            }
                        }
                    },
                    endDate: {
                        validators: {
                            notEmpty: {message: 'This field is required.'},
                            callback: {
                                message: 'End Date must greater than or equal to Start Date.',
                                callback: function (endDate, validator, $field) {
                                    return checkDateRange(window.$('#' + startDateId).val(), endDate);
                                }
                            }
                        }
                    },
                    customize: {
                        validators: {
                            customize: {message: 'customize.'}
                        }
                    }
                };
                if (!bstpValidate) {
                    jqForm.bootstrapValidator({
                        excluded: [':disabled'],
                    })
                }

                jqForm.bootstrapValidator('addField', startDateId, validateFields.startDate);
                jqForm.bootstrapValidator('addField', endDateId, validateFields.endDate);

            };

            let hookValidatorEvt = function () {
                let dateBlur = function (e, bundleDateId, action) {
                    jqForm.bootstrapValidator('revalidateField', e.target.id);
                };

                window.$('#' + startDateId).on("dp.change dp.update blur", function (e) {
                    window.$('#' + endDateId).data("DateTimePicker").setMinDate(e.date);
                    dateBlur(e, endDateId);
                });

                window.$('#' + endDateId).on("dp.change dp.update blur", function (e) {
                    window.$('#' + startDateId).data("DateTimePicker").setMaxDate(e.date);
                    dateBlur(e, startDateId);
                });
            };

            bindValidator();
            hookValidatorEvt();
        };

        let state = this.props;
        let dateRangeHandler = this.handleChangedDateRange;

        window.$(function () {
            let start = state.startDate;
            let end = state.endDate;
            if (start == null) {
                start = moment.utc().subtract(7, 'days').format('MM/DD/YYYY');
                end = moment.utc().subtract(1, 'days').format('MM/DD/YYYY');
            }
            let sd = new Date(start), ed = new Date(end);

            window.$('#startDate').datetimepicker({
                pickTime: false,
                format: "MM/DD/YYYY",
                defaultDate: sd,
                maxDate: ed
            }).on("dp.change", function (e) {
                dateRangeHandler(window.$('#startDate'), true)
            });


            window.$('#endDate').datetimepicker({
                pickTime: false,
                format: "MM/DD/YYYY",
                defaultDate: ed,
                minDate: sd
            }).on("dp.change", function (e) {
                dateRangeHandler(window.$('#endDate'), false)
            }).on("dp.s");

            //passing 1.jquery form object, 2.start date dom Id, 3.end date dom Id
            bindDateRangeValidation(window.$("#form"), 'startDate', 'endDate');
        });
    }

    componentWillMount() {
        let filter = this.props.filter;
        let filterCat = this.props.filterCat;
        if (filter === null) {
            filterCat = '1W';
            filter = this.defaultFilter()
        }
        let scope = this.props.scope;
        if (scope === null) {
            scope = 'all'
        }
        let plan = this.props.plan;
        if (plan === null) {
            plan = "spot"
        }
        this.props.onFetchDashboard(this.props.token, filter, this.props.filter, scope, this.props.scope, plan, this.props.plan, filterCat);
    }

    toDate = (millis, inclusive) => {
        if (inclusive) {
            return moment(millis - 1).utc().format('MM/DD/YYYY');
        }
        return moment(millis).utc().format("MM/DD/YYYY")
    };


    defaultFilter = () => {
        return [this.toMillis(moment.utc().subtract(7, 'days').format('MM/DD/YYYY'), false), this.toMillis(moment.utc().subtract(1, 'days').format('MM/DD/YYYY'), true)]
    };

    catToFilter = (filterCat) => {
        if (filterCat === '1W') {
            return this.defaultFilter()
        } else if (filterCat === '4W') {
            return [this.toMillis(moment.utc().subtract(28, 'days').format('MM/DD/YYYY'), false), this.toMillis(moment.utc().subtract(1, 'days').format('MM/DD/YYYY'), true)]
        } else if (filterCat === '1Y') {
            return [this.toMillis(moment.utc().subtract(12, 'months').date(1).format('MM/DD/YYYY'), false), this.toMillis(moment.utc().subtract(1, 'days').format('MM/DD/YYYY'), true)]
        } else if (filterCat === 'MTD') {
            return [this.toMillis(moment.utc().date(1).format('MM/DD/YYYY'), false), this.toMillis(moment.utc().format('MM/DD/YYYY'), true)]
        } else if (filterCat === 'QTD') {
            let q = moment.utc().quarter();
            if (q === 1) {
                return [this.toMillis(moment.utc().month(0).date(1).format('MM/DD/YYYY'), false), this.toMillis(moment.utc().format('MM/DD/YYYY'), true)]
            } else if (q === 2) {
                return [this.toMillis(moment.utc().month(3).date(1).format('MM/DD/YYYY'), false), this.toMillis(moment.utc().format('MM/DD/YYYY'), true)]
            } else if (q === 3) {
                return [this.toMillis(moment.utc().month(6).date(1).format('MM/DD/YYYY'), false), this.toMillis(moment.utc().format('MM/DD/YYYY'), true)]
            } else {
                return [this.toMillis(moment.utc().month(9).date(1).format('MM/DD/YYYY'), false), this.toMillis(moment.utc().format('MM/DD/YYYY'), true)]
            }
        } else if (filterCat === 'YTD') {
            return [this.toMillis(moment.utc().month(0).date(1).format('MM/DD/YYYY'), false), this.toMillis(moment.utc().format('MM/DD/YYYY'), true)]
        }
    };


    toMillis = (d, inclusive) => {
        if (inclusive) {
            return moment.utc(d).add(1, 'days').valueOf();
        }
        return moment.utc(d).valueOf();
    };

    // Create our number formatter.
    formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        // the default value for minimumFractionDigits depends on the currency
        // and is usually already 2
    });

    formatNum = (x) => {
        return this.formatter.format(x)
    };

    formatPercent = (x) => {
        return Number.parseFloat(x).toFixed(2)
    };

    componentDidUpdate(props, states, snapshot) {
        window.$(function () {
            window.jcf.replaceAll();
        });
        if (props.filter === this.props.filter) {

            return
        }

        let startPicker = window.$('#startDate').data('DateTimePicker');
        let endPicker = window.$('#endDate').data('DateTimePicker');

        let filter = this.props.filter;

        if (filter === null || filter === undefined) {
            return
        }
        startPicker.setDate(this.toDate(filter[0], false));

        endPicker.setDate(this.toDate(filter[1], true));
    }

    redirectToSettings = (event) => {
        event.preventDefault();
        this.props.history.push("/accountSettings")
    };

    redirectToDashboard = (event) => {
        event.preventDefault();
        this.props.history.push("/dashboard")
    };

    redirectToXogroups = (event) => {
        event.preventDefault();
        this.props.history.push("/xogroups")
    };

    redirectToScheduler = (e) => {
        e.preventDefault();
        this.props.history.push("/schedulers")
    };

    redirectToInstallation = (event) => {
        event.preventDefault();
        this.props.history.push("/installation")
    };

    redirectToBudget = (e) => {
        e.preventDefault();
        this.props.history.push("/budgets")
    };

    redirectToAlerts = (e) => {
        e.preventDefault();
        this.props.history.push("/alerts")
    }

    buildValue = (hoveredCell) => {
        const {radius, angle, angle0} = hoveredCell;
        const truedAngle = (angle + angle0) / 2;

        return {
            x: radius * Math.cos(truedAngle),
            y: radius * Math.sin(truedAngle)
        }
    };

    handleChangedDateRange = (d, isStart) => {
        if (this.props.filter === null) {
            return
        }
        let s = this.props.filter[0];
        let e = this.props.filter[1];
        let filter = [];
        if (isStart) {
            filter = [moment.utc(d.val()).valueOf(), e]
        } else {
            // filter = [this.toMillis(s), moment.utc(d.val()).valueOf()]
            filter = [s, this.toMillis(moment.utc(d.val()), true)]
        }


        // if (isStart && moment.utc(d.val()).valueOf() === this.toMillis(s)) {
        if (isStart && moment.utc(d.val()).valueOf() === s) {
            return
        }
        // if (!isStart && moment.utc(d.val()).valueOf() === this.toMillis(e)) {
        if (!isStart && this.toMillis(moment.utc(d.val()), true) === e) {
            return
        }
        this.props.onFetchDashboard(this.props.token, filter, this.props.filter, this.state.scope, this.state.scope, this.props.plan, this.props.plan, '');
    };

    handleFilter = (event, filterCat) => {
        event.preventDefault();
        this.setState({filterCat: filterCat});
        let filter = this.catToFilter(filterCat);
        this.props.onFetchDashboard(this.props.token, filter, this.props.filter, this.state.scope, this.state.scope, this.state.plan, this.state.plan, filterCat);
    };

    handleScope = e => {
        e.preventDefault();
        this.setState({scope: e.target.value});

        this.props.onChangeScope(this.props.token, this.props.filter, e.target.value, this.props.scope, this.props.plan, this.state.filterCat);
    };

    handlePlan = e => {
        e.preventDefault();
        this.setState({plan: e.target.value});
        this.props.onChangePlan(this.props.token, this.props.filter, this.props.scope, e.target.value, this.props.plan, this.state.filterCat)
    }

    handleReservationType = (e) => {
        this.props.onChangeReservationType(e.target.value)
    };

    getSavings = () => {
        if (this.props.reservationType === 'onDemand' || this.props.reservationType === '') {
            return this.props.dashboard.overview.onDemandCosts -  this.props.dashboard.overview.spotCosts;
        } else {
            return this.props.dashboard.overview[this.props.reservationType] -  this.props.dashboard.overview.spotCosts;
        }
    };

    getSavingsPct = (savings) => {
        if (this.props.reservationType === 'onDemand' || this.props.reservationType === '') {
            return (savings / this.props.dashboard.overview.onDemandCosts) * 100
        } else {
            return (savings / this.props.dashboard.overview[this.props.reservationType]) * 100
        }
    };

    handleLogout = () => {
        this.props.onLogout(this.props.token)
    };

    render() {
        const tipStyle = {
            display: 'flex',
            color: '#fff',
            background: '#000',
            alignItems: 'center',
            padding: '5px'
        };
        const boxStyle = {height: '10px', width: '10px'};

        let maxSpots = null;
        let currentInstances = null;
        let savings = null;
        let hours = null;
        let savingPct = null;
        let onDemandCosts = null;
        let reservedCosts = null;
        let spotCosts = null;
        if (this.props.dashboard.overview && this.props.dashboard.overview.maxSpots) {
            maxSpots = this.props.dashboard.overview.maxSpots.toLocaleString();
            currentInstances = this.props.dashboard.overview.currentSpots.toLocaleString();
            const savingNum = this.getSavings();
            savings = this.formatNum(savingNum);
            hours = this.props.dashboard.overview.hours.toLocaleString();
            savingPct = this.formatPercent(this.getSavingsPct(savingNum));
            onDemandCosts = this.formatNum(this.props.dashboard.overview.onDemandCosts);
            reservedCosts = this.formatNum(this.props.dashboard.overview.reservedCosts);
            spotCosts = this.formatNum(this.props.dashboard.overview.spotCosts);
        }
        let perFamily = [];
        let families = [];
        if (this.props.dashboard.byFamily) {
            this.props.dashboard.byFamily.map((p, i) => {
                perFamily.push({name: p.kind, angle: p.value, color: colors[i]});
                families.push({title: p.kind, color: colors[i]});
                return null
            });
        }
        let perType = [];
        let types = [];
        if (this.props.dashboard.byType) {
            this.props.dashboard.byType.map((p, i) => {
                perType.push({name: p.kind, angle: p.value, color: colors[i]});
                types.push({title: p.kind, color: colors[i]});
                return null
            });
        }

        let perAz = [];
        let azs = [];
        if (this.props.dashboard.byAz) {
            this.props.dashboard.byAz.map((p, i) => {
                perAz.push({name: p.kind, angle: p.value, color: colors[i]});
                azs.push({title: p.kind, color: colors[i]});
                return null
            });
        }


        let spotHours = [];
        if (this.props.dashboard.spotHours) {
            spotHours = this.props.dashboard.spotHours
        }
        let instances = [];
        let tickValues = [];
        if (this.props.dashboard.instances) {
            instances = this.props.dashboard.instances;
            instances.forEach(function (i) {
                tickValues.push(i.x);
            })
        }
        // let selectedOption = options.find(r => {
        //     return r.value === this.props.reservationType
        // });
        // let selected = {value: this.props.reservationType, label: selectedOption ? selectedOption.label : null}
        //
        // if (!selectedOption) {
        //     selected = options[0]
        // }

        let active1, active2, active3, active4, active5, active6 = null;
        if (this.props.filterCat === '1W') {
            active1 = 'active';
        }
        if (this.props.filterCat === '4W') {
            active2 = 'active';
        }
        if (this.props.filterCat === '1Y') {
            active3 = 'active';
        }
        if (this.props.filterCat === 'MTD') {
            active4 = 'active';
        }
        if (this.props.filterCat === 'QTD') {
            active5 = 'active';
        }
        if (this.props.filterCat === 'YTD') {
            active6 = 'active';
        }
        if (this.props.dashboard.projects) {
            this.props.dashboard.projects.sort(function (a, b) {
                let aval = a.name ? a.name : a.id;
                let bval = b.name ? b.name : b.id;
                if (aval < bval) return -1;
                if (aval > bval) return 1;
                return 0;
            });
        }
        return (
            <div className="wrapper">

                <Loader fullPage={true} loading={this.props.loading}/>

                <div className="navbar navbar-dark bg-dark d-block d-md-none mob-nav fixed-top">
                    <button className="navbar-toggler pull-right" type="button" data-toggle="offcanvas"><span
                        className="navbar-toggler-icon"></span></button>
                    <div className="nav-item dropdown logo pull-left"><a className="dropdown-toggle text-white"
                                                                         href="http://example.com" id="dropdown10"
                                                                         data-toggle="dropdown" aria-haspopup="true"
                                                                         aria-expanded="false">
                        <div className="company-logo">
                            <div className="inner-logo rounded-circle img-thumbnail"><img src={maleAvatar}
                                                                                          alt="" title=""/></div>
                        </div>
                        {this.props.company}</a>
                        <div className="dropdown-menu" aria-labelledby="dropdown10">
                            <a className="dropdown-item" href="#">{this.props.company}</a>
                            <a className="dropdown-item" href="#" onClick={this.handleLogout}>Logout</a></div>
                    </div>
                </div>
                <div className="sidebar offcanvas-collapse">
                    <div className="sidebar-wrapper">
                        <div className="dropdown logo d-none d-md-block"><a href="/"
                                                                            className="simple-text dropdown-toggle"
                                                                            data-toggle="collapse"
                                                                            data-target="#dropdown11">
                            <div className="company-logo">
                                <div className="inner-logo rounded-circle img-thumbnail"><img
                                    src={maleAvatar} alt="" title=""/></div>
                            </div>
                            {this.props.company} </a>
                            <div className="dropdown-menu collapse" id="dropdown11">
                                <a className="dropdown-item" href="#">{this.props.company}</a>
                                <a className="dropdown-item" href="#" onClick={this.handleLogout}>Logout</a>
                            </div>
                        </div>
                        <ul className="nav">
                            {
                                this.props.gcpOnly ? null :
                                    (<li><a href="#" onClick={this.redirectToDashboard}> <i className="fa fa-bar-chart"></i>
                                        <p>AWS Dashboard</p>
                                    </a></li>)
                            }

                            <li className="active"><a href="#"> <i className="fa fa-bar-chart"></i>
                                <p>GCP Dashboard</p>
                            </a></li>
                            <li><a href="#" onClick={this.redirectToXogroups}> <i className="com-icon"><img
                                src={computerIcon} alt="" title=""/></i>
                                <p>Xogroups</p>
                            </a></li>
                            <li><a href="#" onClick={this.redirectToBudget}> <i className="fa fa-dollar"></i>
                                <p>Budgets</p>
                            </a></li>
                            <li><a href="#" onClick={this.redirectToScheduler}> <i className="fa fa-calendar"></i>
                                <p>Schedules</p>
                            </a></li>
                            <li><a href="#" onClick={this.redirectToAlerts}> <i className="com-icon"><img
                                src={alertsIcon} alt="" title="" width="25"/></i>
                                <p>Alerts</p>
                            </a></li>
                            <li><a href="#" onClick={this.redirectToInstallation}> <i className="fa fa-wrench"></i>
                                <p>Installation</p>
                            </a></li>
                            <li><a href="#" onClick={this.redirectToSettings}> <i className="fa fa-gear"></i>
                                <p>Settings</p>
                            </a></li>
                        </ul>
                    </div>
                </div>

                <div className="main-panel">
                    <div className="content">

                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xl-2 col-lg-3 mb-3">
                                    <select defaultValue={this.state.scope} onChange={e => this.handleScope(e)}>
                                        <optgroup label="Projects">
                                            <option value="all">All</option>
                                            {
                                                this.props.dashboard.projects ?
                                                this.props.dashboard.projects.map((k, index) => {
                                                    return (
                                                        <option key={index}
                                                                value={k.id}>{k.name ? k.name : k.id}</option>
                                                    )
                                                }) : null
                                            }
                                        </optgroup>
                                        {
                                            this.props.dashboard.scopes && Object.keys(this.props.dashboard.scopes).map((e, i) => {
                                                return <optgroup key={i} label={this.props.dashboard.scopesDisplay[e] ? this.props.dashboard.scopesDisplay[e] : e}>
                                                    {this.props.dashboard.scopes[e].map((v, index) => {
                                                        return <option key={index}
                                                                       value={e.concat("(_xosphere_scope_splitter_)").concat(v)}>{v}</option>
                                                    })}
                                                </optgroup>

                                            })
                                        }
                                    </select>
                                </div>
                                <div className="col-xl-2 col-lg-3 mb-3">
                                    <select defaultValue={this.state.plan} onChange={e => this.handlePlan(e)}>
                                        <option value="spot">Spot</option>
                                        <option value="ri">CUD</option>
                                        <option value="combined">All</option>
                                    </select>
                                </div>
                                <div className="col-xl-3 col-lg-3 mb-3">
                                    <ul className="timeline">
                                        <li className={active1}><a href="#"
                                                                   onClick={e => this.handleFilter(e, '1W')}>1w</a></li>
                                        <li className={active2}><a href="#"
                                                                   onClick={e => this.handleFilter(e, '4W')}>4w</a></li>
                                        <li className={active3}><a href="#"
                                                                   onClick={e => this.handleFilter(e, '1Y')}>1y</a></li>
                                        <li className={active4}><a href="#"
                                                                   onClick={e => this.handleFilter(e, 'MTD')}>Mtd</a>
                                        </li>
                                        <li className={active5}><a href="#"
                                                                   onClick={e => this.handleFilter(e, 'QTD')}>Qtd</a>
                                        </li>
                                        <li className={active6}><a href="#"
                                                                   onClick={e => this.handleFilter(e, 'YTD')}>Ytd</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-xl-5 col-lg-6 mb-3">
                                    <table width="100%" cellPadding="0" cellSpacing="0" border="0"
                                           className="select-dates">
                                        <tbody>
                                        <tr>
                                            <td>
                                                <div className="calender-icon">
                                                    <input id="startDate" name="startDate" type="text"
                                                           className="form-control"/>
                                                    <i className="fa fa-calendar"></i>
                                                </div>
                                            </td>
                                            <td valign="middle" align="center" width="30">to</td>
                                            <td>
                                                <div className="calender-icon">
                                                    <input id="endDate" name="endDate" type="text"
                                                           className="form-control"/>
                                                    <i className="fa fa-calendar"></i>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="header">
                                            <h4 className="title">Overview</h4>
                                        </div>
                                        <div className="content">
                                            <div className="row">
                                                <div className="col-lg-3 col-sm-6">
                                                    <div className="card">
                                                        <div className="content">
                                                            <div className="icon-big icon-warning text-center"><i
                                                                className="ti-server"></i></div>
                                                            {
                                                                maxSpots ? <div className="numbers"> {maxSpots} / {currentInstances}</div> :<div className="numbers"> &nbsp;</div>
                                                            }
                                                            <div className="footer text-center">
                                                                <hr/>
                                                                <div className="stats">
                                                                    <i className="ti-reload"></i> VM Instances (Peak/Current)
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-sm-6">
                                                    <div className="card">
                                                        <div className="content">
                                                            <div className="icon-big icon-warning text-center"><i
                                                                className="ti-server"></i></div>
                                                            {
                                                                hours ? <div className="numbers"> {hours}</div> : <div className="numbers">&nbsp;</div>
                                                            }
                                                            <div className="footer text-center">
                                                                <hr/>
                                                                <div className="stats"><i
                                                                    className="ti-reload"></i> VM Instance Hours
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-sm-6">
                                                    <div className="card">
                                                        <div className="content">
                                                            <div className="icon-big icon-warning text-center"><i
                                                                className="ti-server"></i></div>
                                                            {
                                                                savings ? <div className="numbers"> {savings}</div> : <div className="numbers">&nbsp;</div>
                                                            }
                                                            <div className="footer text-center">
                                                                <hr/>
                                                                <div className="stats"><i
                                                                    className="ti-reload"></i> Savings
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-sm-6">
                                                    <div className="card">
                                                        <div className="content">
                                                            <div className="icon-big icon-warning text-center"><i
                                                                className="ti-server"></i></div>
                                                            {
                                                                savingPct ? <div
                                                                    className="numbers"> {savingPct}%
                                                                </div> : <div
                                                                    className="numbers">&nbsp;
                                                                </div>
                                                            }

                                                            <div className="footer text-center">
                                                                <hr/>
                                                                <div className="stats"><i
                                                                    className="ti-reload"></i> Percent Saved
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                this.props.plan === "spot" || this.props.plan === null ?
                                                    (<div className="row no-gutters">
                                                        <div className="col-md-8 text-right">
                                                            <label className="mr-2 mt-2">Compared to:</label>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <select value={this.props.reservationType}
                                                                    onChange={e => this.handleReservationType(e)}>
                                                                {
                                                                    options.map((k, index) => {
                                                                        return (
                                                                            <option key={index}
                                                                                    value={k.value}>{k.label}</option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>) : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="header">
                                            <h4 className="title">Cost Comparison <a
                                                className="btn btn-sm btn-link blue pl-1" title="Details"
                                                data-toggle="modal" data-target="#CostComparisonDetails"><i
                                                className="fa fa-info-circle"></i></a></h4>
                                        </div>
                                        <div className="content">
                                            <div className="row justify-content-md-center">
                                                <div className="col-lg-3 col-sm-6">
                                                    <div className="card">
                                                        <div className="content">
                                                            <div className="icon-big icon-warning text-center"><i
                                                                className="ti-server"/></div>
                                                            {
                                                                onDemandCosts? <div className="numbers"> {onDemandCosts}</div> : <div className="numbers">&nbsp;</div>
                                                            }
                                                            <div className="footer text-center">
                                                                <hr/>
                                                                <div className="stats"><i
                                                                    className="ti-reload"/> OnDemand<br/>
                                                                    (Potential)
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-sm-6">
                                                    <div className="card">
                                                        <div className="content">
                                                            <div className="icon-big icon-warning text-center">
                                                                <i className="ti-server"/></div>
                                                            {
                                                                reservedCosts ? <div className="numbers"> {reservedCosts}</div> : <div className="numbers">&nbsp;</div>
                                                            }
                                                            <div className="footer text-center">
                                                                <hr/>
                                                                <div className="stats">
                                                                    <i className="ti-reload"/> CUD<br/>
                                                                    (Potential)
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-sm-6">
                                                    <div className="card">
                                                        <div className="content">
                                                            <div className="icon-big icon-warning text-center">
                                                                <i className="ti-server"/></div>
                                                            {
                                                                spotCosts? <div className="numbers"> {spotCosts}</div>: <div className="numbers">&nbsp;</div>
                                                            }
                                                            <div className="footer text-center">
                                                                <hr/>
                                                                <div className="stats">
                                                                    <i className="ti-reload"/> Xosphere<br/>
                                                                    (Actual)
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="card">
                                        <div className="header">
                                            <h4 className="title">VM Instance Hours</h4>
                                        </div>
                                        <div className="content">
                                            <FlexibleWidthXYPlot xType="time-utc" height={300} animation
                                                                 onMouseLeave={() => this.setState({hourTip: false})}>
                                                <VerticalGridLines/>
                                                <HorizontalGridLines/>
                                                <XAxis tickFormat={(v) => moment(v).utc().format('MM/DD')}
                                                       tickValues={tickValues} tickLabelAngle={-45}/>
                                                <YAxis/>
                                                <VerticalBarSeries data={spotHours} style={{stroke: '#fff'}}
                                                                   color="#0993ef"
                                                                   onNearestX={value => this.setState({hourTip: value})}
                                                    // onNearestXY={value => this.setState({hourTip: value})}
                                                />
                                                {this.state.hourTip ? <Hint value={this.state.hourTip}>
                                                    <div style={tipStyle}>
                                                        <div style={{...boxStyle}}/>
                                                        Spot Hours<br/>
                                                        {this.state.hourTip.y.toLocaleString()}
                                                    </div>
                                                </Hint> : null}
                                            </FlexibleWidthXYPlot>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="card">
                                        <div className="header">
                                            <h4 className="title">VM Instances</h4>
                                        </div>
                                        <div className="content">
                                            <FlexibleWidthXYPlot xType="time-utc" height={300} animation="stiff"
                                                                 yPadding={10}
                                                                 yDomain={[0, this.props.dashboard.overview.maxSpots + 10]}
                                                                 onMouseLeave={() => this.setState({instanceTip: false})}>
                                                <VerticalGridLines/>
                                                <HorizontalGridLines/>
                                                <XAxis tickFormat={(v) => moment(v).utc().format('MM/DD')}
                                                       tickValues={tickValues} tickLabelAngle={-45}/>
                                                <YAxis/>
                                                <LineMarkSeries data={instances} curve={null} opacity={1}
                                                                color="#0993ef"
                                                                onNearestXY={value => this.setState({instanceTip: value})}/>
                                                {this.state.instanceTip ? <Hint value={this.state.instanceTip}>
                                                    <div style={tipStyle}>
                                                        <div style={{...boxStyle}}/>
                                                        Spot Instances<br/>
                                                        {this.state.instanceTip.y.toLocaleString()}
                                                    </div>
                                                </Hint> : null}
                                            </FlexibleWidthXYPlot>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4 col-sm-6">
                                    <div className="card" style={{height: "100%"}}>
                                        <div className="header">
                                            <h4 className="title">Machine Family</h4>
                                        </div>
                                        <div className="content">

                                            <RadialChart
                                                colorType="literal"
                                                getLabel={d => d.name}
                                                data={perFamily}
                                                labelsStyle={{fontSize: 16, fill: '#222'}}
                                                style={{stroke: '#fff', strokeWidth: 2}}
                                                width={400}
                                                height={200}
                                                onValueMouseOver={v => {
                                                    this.setState({hoveredCell: v.x && v.y ? v : false})
                                                }}
                                                onValueMouseOut={v => this.setState({hoveredCell: false})}
                                            >
                                                {this.state.hoveredCell ? (
                                                    <Hint value={this.buildValue(this.state.hoveredCell)}>
                                                        <div style={tipStyle}>
                                                            <div style={{...boxStyle}}/>
                                                            {this.state.hoveredCell.name}: {perFamily.filter(v => v.name === this.state.hoveredCell.name)[0].angle.toLocaleString()}
                                                        </div>
                                                    </Hint>
                                                ) : null}
                                            </RadialChart>
                                            <div className="legend-list">
                                                <DiscreteColorLegend items={families} colors={colors}
                                                                     orientation="horizontal"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-sm-6">
                                    <div className="card" style={{height: "100%"}}>
                                        <div className="header">
                                            <h4 className="title">Machine Type</h4>
                                        </div>
                                        <div className="content">
                                            <RadialChart
                                                colorType="literal"
                                                getLabel={d => d.name}
                                                data={perType}
                                                labelsStyle={{fontSize: 16, fill: '#222'}}
                                                style={{stroke: '#fff', strokeWidth: 2}}
                                                width={400}
                                                height={200}
                                                onValueMouseOver={v => {
                                                    this.setState({hoveredCell2: v.x && v.y ? v : false})
                                                }}
                                                onValueMouseOut={v => this.setState({hoveredCell2: false})}
                                            >
                                                {this.state.hoveredCell2 ? (
                                                    <Hint value={this.buildValue(this.state.hoveredCell2)}>
                                                        <div style={tipStyle}>
                                                            <div style={{...boxStyle}}/>
                                                            {this.state.hoveredCell2.name}: {perType.filter(v => v.name === this.state.hoveredCell2.name)[0].angle.toLocaleString()}
                                                        </div>
                                                    </Hint>
                                                ) : null}
                                            </RadialChart>
                                            <div className="legend-list">
                                                <DiscreteColorLegend items={types} colors={colors}
                                                                     orientation="horizontal"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-sm-6">
                                    <div className="card" style={{height: "100%"}}>
                                        <div className="header">
                                            <h4 className="title">Zone</h4>
                                        </div>
                                        <div className="content">
                                            <RadialChart
                                                colorType="literal"
                                                getLabel={d => d.name}
                                                data={perAz}
                                                labelsStyle={{fontSize: 16, fill: '#222'}}
                                                style={{stroke: '#fff', strokeWidth: 2}}
                                                width={400}
                                                height={200}
                                                onValueMouseOver={v => {
                                                    this.setState({hoveredCell3: v.x && v.y ? v : false})
                                                }}
                                                onValueMouseOut={v => this.setState({hoveredCell3: false})}
                                            >
                                                {this.state.hoveredCell3 ? (
                                                    <Hint value={this.buildValue(this.state.hoveredCell3)}>
                                                        <div style={tipStyle}>
                                                            <div style={{...boxStyle}}/>
                                                            {this.state.hoveredCell3.name}: {perAz.filter(v => v.name === this.state.hoveredCell3.name)[0].angle.toLocaleString()}
                                                        </div>
                                                    </Hint>
                                                ) : null}
                                            </RadialChart>
                                            <div className="legend-list">
                                                <DiscreteColorLegend items={azs} colors={colors}
                                                                     orientation="horizontal"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade bd-example-modal-lg" id="CostComparisonDetails" tabIndex="-1" role="dialog"
                     aria-labelledby="CostComparisonDetailsTitle" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="CostComparisonDetailsTitle"><strong>Cost Comparison
                                    Details</strong></h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="modal-scroll">
                                    <table width="100%" cellPadding="0" cellSpacing="0"
                                           className="table alt-rows responsive-table">
                                        <thead>
                                        <tr>
                                            <th>Instance Type</th>
                                            <th>Availability Zone</th>
                                            <th>Hours</th>
                                            <th>On-Demand Cost (Potential)</th>
                                            <th>Cud Cost (Potential)</th>
                                            <th>Xosphere Cost (Actual)</th>
                                            <th>Effective Savings Rate</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.props.dashboard.details ? this.props.dashboard.details.map((d, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td data-title="Instance Type">{d.instanceType}</td>
                                                    <td data-title="Availability Zone">{d.az}</td>
                                                    <td data-title="Hours" align="right">{d.hours}</td>
                                                    <td data-title="On-Demand Cost (Potential)"
                                                        className="d-line">{this.formatNum(d.onDemandCost)}
                                                    </td>
                                                    <td data-title="Reserved Cost (Potential)"
                                                        className="d-line">{this.formatNum(d.reservedCost)}
                                                    </td>
                                                    <td data-title="Xosphere Cost (Actual)"
                                                        className="d-line">{this.formatNum(d.spotCost + 0.1 * d.onDemandCost)}
                                                    </td>
                                                    <td data-title="ESR" className="d-line">{this.formatPercent(100*(d.onDemandCost - d.spotCost - 0.1 * d.onDemandCost) / d.onDemandCost)}%</td>
                                                </tr>
                                            )
                                        }) : null}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

const mapStateToProps = state => {
    return {
        token: state.settings.token || state.login.token,
        loading: state.gcpDashboard.loading,
        error: state.gcpDashboard.error,
        dashboard: state.gcpDashboard.dashboard,
        filter: state.gcpDashboard.filter,
        filterCat: state.gcpDashboard.filterCat,
        scope: state.gcpDashboard.scope,
        plan: state.gcpDashboard.plan,
        // startDate: state.dashboard.startDate,
        // endDate: state.dashboard.endDate,
        reservationType: state.gcpDashboard.reservationType,
        company: state.login.company,
        hasGcp: state.login.hasGcp,
        gcpOnly: state.login.gcpOnly,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchDashboard: (token, filter, original, scope, prevScope, plan, prevPlan, filterCat) => dispatch(actions.fetchGcpDashboard(token, filter, original, scope, prevScope, plan, prevPlan, filterCat)),
        onChangeReservationType: (reservationType) => dispatch(actions.changeGcpReservationType(reservationType)),
        onChangeScope: (token, filter, scope, prevScope, plan, filterCat) => dispatch(actions.fetchGcpDashboard(token, filter, filter, scope, prevScope, plan, plan, filterCat)),
        onChangePlan: (token, filter, scope, plan, prevPlan, filterCat) => dispatch(actions.fetchGcpDashboard(token, filter, filter, scope, scope, plan, prevPlan, filterCat)),
        onLogout: (token) => dispatch(actions.logout(token))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(GcpDashboard);